import { render, staticRenderFns } from "./StakingCarousel.vue?vue&type=template&id=87600404&scoped=true"
import script from "./StakingCarousel.vue?vue&type=script&lang=js"
export * from "./StakingCarousel.vue?vue&type=script&lang=js"
import style0 from "./StakingCarousel.vue?vue&type=style&index=0&id=87600404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87600404",
  null
  
)

export default component.exports